
import { useState } from 'react'
import { BriefcaseBusiness, Plus, XIcon } from 'lucide-react'
import Style from './style.module.css'
import LeftSidePopupLayout from '../../../../component/popup/modal-layout'
import AddVendorPopup from '../vendor/add-popup'
import AddPopup from '../list/add-popup'

const FuleInvPopup = ({ onClose = () => { }, onError = () => { }, onSubmit = () => { }, currentData, dropdowns, tabIndex }) => {
    const [navIndex, setNavIndex] = useState(tabIndex || 0);



    const handleNavClick = (index) => {
        setNavIndex(index);
    };

    const navItems = [
        { label: "Fuel Records", icon: <Plus size="1.2em" /> },
        { label: "Vendors", icon: <BriefcaseBusiness size="1.2em" /> },
    ];

    return (
        <>
            <div className={Style.modal_body}>
                <LeftSidePopupLayout popupStatus={true} className={`${Style.departmentChangeModal}`}>
                    <div className={Style.modal_header}>
                        <div className={Style.modal_nav}>
                            <ul>
                                {navItems.map((item, i) => {
                                    console.log("object", tabIndex, navIndex, i)

                                    return (
                                        <li
                                            key={i}
                                            className={`${navIndex === i ? Style.active : ""} ${tabIndex ? navIndex === i ? "" : Style.disabled : ""}`}
                                            onClick={() => {
                                                if (tabIndex) {
                                                    if (!navIndex === i) {
                                                        handleNavClick(i);
                                                    }
                                                } else {
                                                    handleNavClick(i);
                                                }
                                            }}
                                        >
                                            <div className={Style.icon}>{item.icon}</div>
                                            <span>{item.label}</span>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>

                        <div
                            className={Style.close_btn}
                            style={{
                                position: 'absolute',
                                top: '-16px',
                                right: '-16px'
                            }}
                            onClick={() => { onClose() }}
                        ><XIcon size={'1em'} /></div>
                    </div>

                    {
                        navIndex === 0 && (
                            <AddPopup
                                onClose={onClose}
                                onError={onError}
                                onSubmit={onSubmit}
                                currentData={currentData}
                                dropdowns={dropdowns}
                                Style={Style}
                            />
                        )
                    }

                    {
                        navIndex === 1 && (
                            <AddVendorPopup
                                onClose={onClose}
                                onError={onError}
                                onSubmit={onSubmit}
                                currentData={currentData}
                                Style={Style}
                            />
                        )
                    }
                </LeftSidePopupLayout>
            </div>
        </>
    )
}

export default FuleInvPopup
